import { IInitOption } from '@visactor/vchart';

export { IInitOption as IOptions };
